function updateDataPDP(target){

  const isBestSeller     = target.dataset.isbestseller;
  const isOnDisplay      = target.dataset.isondisplay;
  const introductionDate = target.dataset.introductiondate;
  const dateduration     = target.dataset.dateduration;
  const variantTitleName = target.dataset.name;
  const variantID = target.dataset.id;
  const storefrontApiKey = target.dataset.storefrontkey;
  const storefrontversion = target.dataset.storefrontversion;
  const customerCurrentLocation = target.dataset.currentlocation;
  const pickupInfo = target.dataset.pickupinfo;
  const skuInfo = target.dataset.sku;
  const imageValue = target.dataset.image;
  const barcodeValue = target.dataset.barcode;
  const currencyValue = target.dataset.currency;
  const varintTitleAbovePills = target.dataset.quickname;
  const specificationPdf= target.dataset.specificationpdf;
  const instructionPdf= target.dataset.instructionpdf;

  const isQuickShop = document.querySelector("#quickShopDrawer");
  if(isQuickShop){

  const quickShopInstructionLink = document.querySelector('#quickShopDrawer .instruction-pdf .instruction-pdf-link');
  const quickShopSpecificationLink = document.querySelector('#quickShopDrawer .specificiation-pdf .specificiation-pdf-link');


  if (specificationPdf && quickShopSpecificationLink) {
    quickShopSpecificationLink.href = specificationPdf;
  }

  if (instructionPdf && quickShopInstructionLink) {
    quickShopInstructionLink.href = instructionPdf;
  }


    const quickShopProductTitle = document.querySelector('#quickShopDrawer .product__title');
    if(quickShopProductTitle){
      quickShopProductTitle.textContent = variantTitleName;
    }

    const quickShopBarcode = document.querySelector('#quickShopDrawer .quick-barcode');
    if(quickShopBarcode){
      quickShopBarcode.textContent = barcodeValue;
    }

    const quickShopSku = document.querySelector('#quickShopDrawer .product__sku_value');
    if(quickShopSku){
      quickShopSku.textContent = skuInfo;
    }

    const pillAboveTitle = document.querySelector('#quickShopDrawer .form__label_value');
    if(pillAboveTitle){
      pillAboveTitle.textContent = varintTitleAbovePills;
    }

    const formList = document.querySelector('#quickShopDrawer .product-form form');
    if (formList) {
      const variantInput = formList.querySelector('input.product-variant-id[name="id"]');
      if (variantInput) {
        variantInput.value = variantID;
      }
    }

    const quickShopwishlistVariantUpdate =document.querySelector('#quickShopDrawer .custom-wishlist-button');
    if (quickShopwishlistVariantUpdate) {
          quickShopwishlistVariantUpdate.dataset.variantId = variantID;
    }

    const galleryEl = document.querySelector('#quickShopDrawer #GalleryViewer-quick-shop');
      if (!galleryEl || !galleryEl.swiper) {
        console.warn("Swiper not initialized yet – skipping image slide update.");
        return;
      }

    const swiper = galleryEl.swiper;

      if (imageValue != 'No-image') {

        const cleanSrc = imageValue.split('?')[0];
        const slides = document.querySelectorAll('#quickShopDrawer #GalleryViewer-quick-shop .swiper-slide');


        let foundIndex = -1;

        slides.forEach((slide, index) => {
          const img = slide.querySelector('img');
          if (!img) return;

          const imgSrc = img.src.split('?')[0];

          if (imgSrc.endsWith(cleanSrc.replace(/^\/\//, ''))) {
            foundIndex = slide.dataset.swiperSlideIndex;
          }
        });

        if (foundIndex !== -1) {
          swiper.slideToLoop(parseInt(foundIndex), 300);

          setTimeout(() => {
          }, 400);
        }
      } else {
        // console.log("No matching image found → going to first slide");
        swiper.slideToLoop(0, 300);
      }

 }


 const stickyBar = document.querySelector("sticky-atc-bar");
 if(stickyBar){

  const stickyBarProductTitle = document.querySelector('sticky-atc-bar .sticky-atc-bar__product-title');
  if(stickyBarProductTitle){
    stickyBarProductTitle.textContent = variantTitleName;
  }


  if (imageValue && imageValue !== 'No-image') {
    let finalImage = imageValue.startsWith('//') ? 'https:' + imageValue : imageValue;
    const stickyATCImage = document.querySelector('sticky-atc-bar .sticky-atc-bar__product-image img');
    if (stickyATCImage) {
      stickyATCImage.src = finalImage;
      stickyATCImage.removeAttribute('srcset');
    }
  }

  const wishlistVariantUpdate =document.querySelector('sticky-atc-bar .custom-wishlist-button');
  if (wishlistVariantUpdate) {
        wishlistVariantUpdate.dataset.variantId = variantID;
  }

 }

  const instructionLink = document.querySelector('.product__info-wrapper .instruction-pdf .instruction-pdf-link');
  const specificationLink = document.querySelector('.product__info-wrapper .specificiation-pdf .specificiation-pdf-link');


  if (specificationPdf && specificationLink) {
    specificationLink.href = specificationPdf;
  }

  if (instructionPdf && instructionLink) {
    instructionLink.href = instructionPdf;
  }


  const availableByStore = document.querySelector('.product__info-wrapper .available-quentity-store');
  if (availableByStore) {
    availableByStore.setAttribute("data-selectedVariantId", variantID);
  }

  const pickupOptions = pickupInfo.split('|').map(v => v.trim());
  const availabilityText = document.querySelector('.product__info-wrapper .pickup-delivery-container .delivery-availability');
  const quickshopAvailibility = document.querySelector('#quickShopDrawer .pickup-delivery-container .delivery-availability');

  const hasCarrierDelivery = pickupOptions.includes('Carrier Delivery');
  const hasLocalDelivery = pickupOptions.includes('Local Delivery');
  const hasStorePickup = pickupOptions.includes('Store Pickup');

  if (hasCarrierDelivery) {
    if(availabilityText){
      availabilityText.textContent = "Available";
    }
    if(quickshopAvailibility){
      quickshopAvailibility.textContent = "Available";
    }
  } else {
    if(availabilityText){
      availabilityText.textContent = "Not Available";
    }
    if(quickshopAvailibility){
      quickshopAvailibility.textContent = "Not Available";
    }
  }

  getStoreAvailability(variantID, storefrontApiKey, storefrontversion).then(data => {
        const edges = data?.data?.node?.storeAvailability?.edges || [];
        const currentLocation = customerCurrentLocation.toLowerCase() || "";

        const inventoryUpdate = document.querySelector('.product__info-wrapper .pickup-delivery-container .inventory-available');
        const quickShopInventoryUpdate = document.querySelector('#quickShopDrawer .pickup-address .inventory-available');

        let qty = 0; // default
        if (currentLocation.trim() !== "") {
          const matchedStore = edges.find(edge => {
            const storeLocation = edge.node.location.storeLocation.reference;
            const title = storeLocation.label?.value || storeLocation.name?.value || '';

            return title.toLowerCase().includes(currentLocation);
          });

          if (matchedStore) {
            qty = Math.max(matchedStore.node.quantityAvailable, 0);
          }
        } else {
            console.log("currentLocation empty → Forcing 0");
        }

        if (inventoryUpdate) {
          inventoryUpdate.textContent = qty;
        }

        if(quickShopInventoryUpdate){
          quickShopInventoryUpdate.textContent = qty;
        }
  });


  const variantMainTitle = document.querySelector('.product__info-wrapper .product_title_PDP');
  if(variantMainTitle){
    variantMainTitle.textContent = variantTitleName;
  }

  const bestSellerBadge = document.querySelector('.product__media-wrapper .product__media-container .custom-product-badges .badge--bestseller');
  const onDisplayBadge = document.querySelector('.product__media-wrapper .product__media-container .custom-product-badges .badge--ondisplay');
  const newBadge = document.querySelector('.product__media-wrapper .product__media-container .custom-product-badges .badge--new');

  if (bestSellerBadge) {
    bestSellerBadge.style.display = isBestSeller === "true" ? "block" : "none";
  }

  if (onDisplayBadge) {
    onDisplayBadge.style.display = isOnDisplay === "true" ? "block" : "none";
  }

  const isNewProduct = (() => {
    if (!introductionDate) return false;
    const introDate = new Date(introductionDate);
    if (isNaN(introDate)) return false;

    const today = new Date();
    const diffDays = (today - introDate) / (1000 * 60 * 60 * 24);
    const allowedDays = parseInt(dateduration, 10) || 30;

    return diffDays >= 0 && diffDays <= allowedDays;
  })();

  if (newBadge) {
    newBadge.style.display = isNewProduct ? "block" : "none";
  }

}

if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          updateDataPDP(target)

          this.updateSelectedSwatchValue(event);
          const isQuickShop = document.querySelector("#quickShopDrawer");
          if(!isQuickShop){
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          }
        });

        const initialTarget =
        this.querySelector("input[type='radio']:checked, select option[selected]");

        if (initialTarget) {
          updateDataPDP(initialTarget);
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
